import React from 'react';
import ReactDOM from 'react-dom';
import Highcharts from 'highcharts';

class GraphView extends React.Component{
  constructor(props, context) {
    super(props, context);
    this._component= null;
  }
  // When the DOM is ready, create the chart.
  componentDidMount () {
    // Extend Highcharts with modules
    if (this.props.modules) {
      this.props.modules.forEach(function (module) {
        module(Highcharts);
      });
    }
  }

  //Destroy chart before unmount.
  componentWillUnmount () {
    this.chart.destroy();
  }
  makeChart (props, component) {
    // Set container which the chart should render to.
    this.chart = new Highcharts[props.type || "Chart"](
      component = ReactDOM.findDOMNode(this),
      props.options
    );
  }
  setNMake (component) {
    this.makeChart(this.props, component);
  }
  //Create the div which the chart will be rendered to.
  render () {
    return (
      <div ref={(c) => c ? this.setNMake(c):null}>
      </div>
    );
  }
}

export default GraphView;



// WEBPACK FOOTER //
// ./src/component/graph/GraphView.js